import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'universalSort',
  standalone: true,
})
export class UniversalSorter implements PipeTransform {
  transform(array: any[], field: string, asc = true): any[] {
    if (!Array.isArray(array)) {
      return [];
    }
    const sorted = [...array].sort((a: any, b: any) => {
      if (a[field] == null && b[field] == null) return 0;
      if (a[field] == null) return -1;
      if (b[field] == null) return 1;

      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return asc ? sorted : sorted.reverse();
  }
}
